import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptQueryString, transformRequest } from '../../../utils/API/requestMiddleware';
import { defautBaseQuery } from '../../../utils/API/fetchBaseQuery';
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";

const xeroPaymentApi = createApi({
    reducerPath: 'xeroPaymentApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getXeroPaymentUpdateTaskList: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/Xero/XeroPaymentUpdateTaskList`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        getAllPaidInvoices: builder.mutation({
            query: (details) => ({
                url: '/Xero/GetAllPaidInvoices',
                method: 'POST',
                // body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        updateMembershipDetailsAfterPaymentMade: builder.mutation({
            query: (details) => ({
                url: '/BoardMemberManagement/UpdateMembershipDetailsAfterPaymentMade',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        xeroPaymentUpdateTaskListForProductAndService: builder.mutation({
            query: (details) => ({
                url: encryptQueryString(`/ProductAndServiceXero/XeroPaymentUpdateTaskListForProductAndService`),
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        getAllPaidInvoicesForProductAndService: builder.mutation({
            query: (details) => ({
                url: '/ProductAndServiceXero/GetAllPaidInvoicesForProductAndService',
                method: 'POST',
                // body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
    }),
})

export const {
    useGetXeroPaymentUpdateTaskListMutation,
    useGetAllPaidInvoicesMutation,
    useUpdateMembershipDetailsAfterPaymentMadeMutation,
    useXeroPaymentUpdateTaskListForProductAndServiceMutation,
    useGetAllPaidInvoicesForProductAndServiceMutation
} = xeroPaymentApi;

export default xeroPaymentApi;